<template>
  <v-form ref="form" lazy-validation>
    <v-row class="text-center">
      <v-col>
        <span class="text-h6 white--text">{{ $t('warranty.title') }}</span>
      </v-col>
    </v-row>
    <v-container>
      <v-row>
        <v-col offset-md="3" md="6">
          <v-card>
            <v-container fluid>
              <v-row class="mt-3">
                <v-col>
                  <span class="font-weight-bold">{{ $t('warranty.name') }}<span class="red--text">*</span></span>
                  <v-text-field v-model="data.username" :rules="rules.username" counter="32" clearable/>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <span class="font-weight-bold">{{ $t('warranty.email') }}<span class="red--text">*</span></span>
                  <v-text-field v-model="data.email" :rules="rules.email" counter="32" clearable/>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <span class="font-weight-bold">{{ $t('warranty.order') }}<span class="red--text">*</span></span>
                  <v-text-field v-model="data.order" :rules="rules.order" :counter="orderLength" clearable/>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <span class="font-weight-bold">{{ $t('warranty.market') }}<span class="red--text">*</span></span>
                  <v-select :items="markets" v-model="data.marketId"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <span class="font-weight-bold">{{ $t('warranty.interested') }}</span>
                  <v-switch v-model="data.subscribe"/>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions>
              <v-spacer/>
              <v-btn :loading="loading" @click="submit" large color="primary" class="mb-3">{{
                  $t('warranty.submit')
                }}
              </v-btn>
              <v-spacer/>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: "WarrantyPage",
  computed: {
    orderLength() {
      return this.data.order && this.data.order.includes('-') ? 19 : 17
    }
  },
  data() {
    return {
      loading: false,
      markets: [
        {
          value: 'US',
          text: 'Amazon US'
        }, {
          value: 'CA',
          text: 'Amazon CA'
        }, {
          value: 'UK',
          text: 'Amazon UK'
        }, {
          value: 'DE',
          text: 'Amazon DE'
        }, {
          value: 'JP',
          text: 'Amazon JP'
        }, {
          value: 'FR',
          text: 'Amazon FR'
        }, {
          value: 'IT',
          text: 'Amazon IT'
        }, {
          value: 'ES',
          text: 'Amazon ES'
        }],
      data: {
        qrcodeId: 'DAYDAUP',
        giftId: 4,
        marketId: null,
        username: null,
        email: null,
        order: null,
        subscribe: false
      },
      rules: {
        username: [
          v => !!v && v.length <= 32 || this.$t('warranty.nameAlert')
        ],
        email: [
          v => !!v && v.length <= 32 || this.$t('warranty.emailAlert'),
          v => /^[\\.a-zA-Z0-9_-]+[@＠][a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(v) || this.$t('warranty.emailAlert2')
        ],
        order: [
          v => !!v && v.length <= this.orderLength &&
              /^\d{17}$/.test(v) || /^\d{3}-\d{7}-\d{7}$/.test(v)
              || this.$t('warranty.orderAlert')
        ]
      }
    }
  },
  methods: {
    initTestData() {
      if (process.env.NODE_ENV === "development") {
        this.data.username = "eplang";
        this.data.email = "ep_lang@163.com";
        this.data.order = "113-8952762-7325850";
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$axios.post('/public/warranty', this.getFormData(this.data)).then(
            () => {
              this.loading = false
              this.$router.push('/finished')
            }
        ).catch(
            err => {
              if (!err.handled) {
                alert(err.message)
              }
              this.loading = false
            }
        )
      }
    },
    getFormData(data) {
      let formData = new FormData();

      for (let key in data) {
        if (data[key] != null) {
          formData.append(key, data[key]);
        }
      }

      return formData;
    }
  },
  mounted() {
    this.$i18n.locale = this.$route.params.lang.toUpperCase()
    this.data.marketId = this.$route.params.lang.toUpperCase()
    this.initTestData()
  }
}
</script>

<style scoped>

</style>